"use strict";

require("../../style/index.css");

require("./index.css");


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/antd/lib/tooltip/style/css.js
// module id = 531
// module chunks = 20